.uninstall-agent-section {
  margin-top: calc(2 * var(--spacer));
}

b {
  font-weight: 600;
}

gz-text {
  color: var(--body-text-arrows-400);

  &.text-light {
    color: var(--body-text-arrows-400);
  }
}
